module.exports = __webpack_public_path__ + "static/media/christian-bermes.e49a72cc.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Particles/Particle05/christian-bermes.png
 ** module id = 139
 ** module chunks = 0
 **/